import script from "./TuiEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./TuiEditor.vue?vue&type=script&setup=true&lang=js"

import "./TuiEditor.vue?vue&type=style&index=0&id=54547c9a&lang=css"

const __exports__ = script;

export default __exports__